module.exports = __webpack_public_path__ + "static/media/tajam.039e6c56.png";